import {
  GetInTouchFiledSection,
  HomeAboutUsSectionFormField,
  HomeAgentRegistrationSectionFormField,
  HomeBannerSectionFormFields,
  HomeBusinessSetupSectionFormField,
  HomeFAQsSectionFormField,
  HomeMediaSectionFormField,
  HomeNewsSectionFormField,
  HomePartnersSectionFormField,
  HomeServicesSectionFormField,
  HomeSocialMediaSectionFormField,
  HomeTestimonialSectionFormField,
  HomeWCUSectionFormField,
} from "@/components";

const HomePageCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  addOnlyValueRepeaterChange,
  removeOnlyValueRepeaterChange,
  updateOnlyValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  return (
    <>
      {/* Banner Section */}
      {selectedTab === "section-1" && (
        <HomeBannerSectionFormFields
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          handleTextEditorInputChange={handleTextEditorInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* About us Section */}
      {selectedTab === "section-2" && (
        <HomeAboutUsSectionFormField
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* Why Choose Us Section */}
      {selectedTab === "section-3" && (
        <HomeWCUSectionFormField
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          handleTextEditorInputChange={handleTextEditorInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* Partners Section */}
      {selectedTab === "section-4" && (
        <HomePartnersSectionFormField
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          addOnlyValueRepeaterChange={addOnlyValueRepeaterChange}
          removeOnlyValueRepeaterChange={removeOnlyValueRepeaterChange}
          updateOnlyValueRepeaterChange={updateOnlyValueRepeaterChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
          colorGrade={colorGrade}
        />
      )}

      {/* Our Services Section */}
      {selectedTab === "section-5" && (
        <HomeServicesSectionFormField
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
        />
      )}

      {/* Business Setup Section */}
      {selectedTab === "section-6" && (
        <HomeBusinessSetupSectionFormField
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* Social Media Section */}
      {selectedTab === "section-7" && (
        <HomeSocialMediaSectionFormField
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
        />
      )}

      {/* Testomial Section */}
      {selectedTab === "section-8" && (
        <HomeTestimonialSectionFormField
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
        />
      )}

      {/* Faqs Section */}
      {selectedTab === "section-9" && (
        <HomeFAQsSectionFormField
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
        />
      )}

      {/* Media Section */}
      {selectedTab === "section-10" && (
        <HomeMediaSectionFormField
          isFetching={isFetching}
          stateDetails={formData}
          handleTextInputChange={handleTextInputChange}
        />
      )}

      {/* Agent Registration Section */}
      {selectedTab === "section-11" && (
        <HomeAgentRegistrationSectionFormField
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}

      {/* Media Section */}
      {selectedTab === "section-12" && (
        <GetInTouchFiledSection
          activeLang={activeTab}
          isFetching={isFetching}
          allFilesResponse={allFilesResponse}
          searchValue={searchValue}
          selectedFileType={selectedFileType}
          onChangeImage={handleImageChange}
          handleTextInputChange={handleTextInputChange}
          handleTextEditorInputChange={handleTextEditorInputChange}
          stateDetails={formData}
          adminRole={adminRole}
          permissionsList={permissionsList}
        />
      )}
    </>
  );
};

export default HomePageCMSForm;
